import { EntityStatus, DeviceModelActions } from "../Constants/Constants";

/**
 * @param {*} data : response from get all device models api
 * @returns Array of objects as required by device model table
 */
export const convertDeviceModelList = (data, key = "devicemodels") => {
  const list = data[key] || [];
  return list.map((item) => {
    return {
      key: item.devicemodelid,
      modelId: item.devicemodelid,
      modelNumber: item.modelnumber,
      modelName: item.modelname,
      manufacturer: item.manufacturer,
      manufacturerOui: item.manufactureroui,
      hardwareVersion: item.hardwareversion,
      additionalHardwareVersion: item.additionalhardwareversion,
      supportedPlatforms: item.supportedplatforms,
      productClass: item.productclass,
      deviceType: item.devicetype,
      category: item.category,
      status: item.modelstatus,
      modelDescription: item.modeldescription,
      additionalDetails: item.additionaldetails,
      adhocPairing: item.adhocpairing,
      partnerCreation: item.partnercreation,
    };
  });
};

/**
 * @param {*} data : device model form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertDeviceModelFormToApiValues = (
  data,
  action = DeviceModelActions.add
) => {
  const returnData = {
    modelname: data.modelName,
    manufacturer: data.manufacturer,
    manufactureroui: data.manufacturerOui,
    hardwareversion: data.hardwareVersion,
    additionalhardwareversion: data.additionalHardwareVersion,
    supportedplatforms: data.supportedPlatforms,
    productclass: data.productClass,
    devicetype: data.deviceType,
    category: data.category,
    modeldescription: data.modelDescription,
    additionaldetails: data.additionalDetails,
    adhocpairing: data.adhocPairing
      ? EntityStatus.Enabled
      : EntityStatus.Disabled,
    partnercreation: data.partnerCreation
      ? EntityStatus.Enabled
      : EntityStatus.Disabled,
  };

  if (action === DeviceModelActions.add) {
    returnData.modelnumber = data.modelNumber;
    returnData.modelstatus = EntityStatus.ACTIVE;
  }
  if (action === DeviceModelActions.edit) {
    returnData.devicemodelid = data.id;
  }
  return returnData;
};

/**
 * @param {*} data : Array of dependent model ids selected for adding
 * @returns Object formatted as required by update device model dependency api
 */
export const convertModelDependencyListToApi = (data) => {
  const returnData = { dependentdevicemodels: [] };
  data.forEach((item) => {
    returnData.dependentdevicemodels.push({ devicemodelid: item });
  });
  return returnData;
};

/**
 * @param {*} data : response from get all device models api
 * @param {*} key : object key which contains required data
 * @returns Array of objects as required by device model dropdown
 */
export const convertDeviceModelListToDropdown = (
  data,
  key = "devicemodels"
) => {
  const list = data[key] || [];
  return list.map((item) => {
    return {
      modelId: item.devicemodelid,
      modelNumber: item.modelnumber,
    };
  });
};
